import '../../sass/blocks/inspiration-gallery.scss';

import cachios from 'cachios';
import Details from '../classes/Details';
import { checkOnScreenEls } from '../common/on-screen';
import { initModals, closeModal, openModal } from '../common/modals.js';
import Macy from 'macy';
import FilterSelection from '../classes/FilterSelection';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $inspirationLists = document.querySelectorAll('.inspiration-gallery');

    if (!$inspirationLists) return;

    $inspirationLists.forEach($inspirationList => {
        const $filterModal = $inspirationList.querySelector('.inspiration-gallery-filter-modal');
        const $filterModalForm = $filterModal?.querySelector('.inspiration-gallery-filter-modal__form');
        const $filterModalFormInputs = $filterModal?.querySelectorAll('input');
        const $filterModalClearAll = $filterModal?.querySelector('.inspiration-gallery-filter-modal__clear-all');
        const $filterSelections = $filterModal?.querySelectorAll('.filter-selection');

        const $filter = $inspirationList.querySelector('.inspiration-gallery-filter');
        const $filterForm = $inspirationList.querySelector('.inspiration-gallery-filter__form');
        const $filterFormSelects = $filterForm?.querySelectorAll('select');

        const $gridInner = $inspirationList.querySelector('.inspiration-gallery-grid__inner');
        const $loadMoreForm = $inspirationList.querySelector('.inspiration-gallery-grid__load-more-form');

        const $modal = $inspirationList.querySelector('.inspiration-gallery-modal');
        const $modalCarousel = $inspirationList.querySelector('.inspiration-gallery-modal__carousel');
        const $modalCarouselInner = $inspirationList.querySelector('.inspiration-gallery-modal__carousel-inner');
        const $modalNavPrev = $inspirationList.querySelector('.inspiration-gallery-modal__nav-btn--previous');
        const $modalNavNext = $inspirationList.querySelector('.inspiration-gallery-modal__nav-btn--next');
        const $modalSlides = $modalCarousel?.querySelectorAll('.swiper-slide');
        const $galleryModalExpandables = $modalCarousel.querySelectorAll('.inspiration-gallery-modal__expandable');

        let modalCarousel = null;

        let masonry = null;

        let loadingMore = true;

        const initCarouselModals = () => {
            const $inspirationGalleryCards = document.querySelectorAll('.inspiration-gallery-card');

            if (!$inspirationGalleryCards) return;

            $inspirationGalleryCards.forEach(($inspirationGalleryCard, index) => {
                const $modalOpenButtons = $inspirationGalleryCard.querySelectorAll('.inspiration-gallery-card .modal-open');
                const $modalCloseButtons = $inspirationGalleryCard.querySelectorAll('.inspiration-gallery-card .modal-close');

                if ($modalOpenButtons) {
                    $modalOpenButtons.forEach($modalOpenButton => {
                        const $modal = $modalOpenButton.dataset?.modalTarget ? document.getElementById($modalOpenButton.dataset.modalTarget) : false;
            
                        if (!$modal) return;

                        $modalOpenButton.addEventListener('click', e => {
                            e.preventDefault();

                            if (modalCarousel) {
                                modalCarousel.slideTo(index, 0);
                            }
                            
                            openModal($modal);
                        });
                    });
                }

                if ($modalCloseButtons) {
                    $modalCloseButtons.forEach($modalCloseButton => {
                        const $modal = $modalCloseButton.dataset?.modalTarget ? document.getElementById($modalCloseButton.dataset.modalTarget) : false;
            
                        if (!$modal) return;

                        $modalCloseButton.addEventListener('click', e => {
                            e.preventDefault();
                            
                            closeModal($modal);
                        });
                    });
                }
            });
        };

        const updateLoadMoreFormFields = ({
            colours,
            products,
            sectors,
            spaces,
            features,
        }) => {
            if (!$loadMoreForm) return;

            const $filterFields = $loadMoreForm.querySelectorAll('[name="form_colours[]"], [name="form_products[]"], [name="form_sectors[]"], [name="form_spaces[]"], [name="form_features[]"]');

            if ($filterFields) {
                $filterFields.forEach($filterField => {
                    $filterField.remove();
                });
            }

            colours?.forEach(colour => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_colours[]" value="${colour}" autocomplete="off">`);
            });

            products?.forEach(product => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_products[]" value="${product}" autocomplete="off">`);
            });

            sectors?.forEach(sector => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_sectors[]" value="${sector}" autocomplete="off">`);
            });

            spaces?.forEach(space => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_spaces[]" value="${space}" autocomplete="off">`);
            });

            features?.forEach(feature => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_features[]" value="${feature}" autocomplete="off">`);
            });
        };

        const setFilterURLParams = ({
            colours,
            products,
            sectors,
            spaces,
            features,
        }) => {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            params.delete('form_colours[]');
            params.delete('form_products[]');
            params.delete('form_sectors[]');
            params.delete('form_spaces[]');
            params.delete('form_features[]');
            params.delete('inspiration_page[]');

            if (colours?.length) {
                colours.forEach(colour => {
                    params.append('form_colours[]', colour);
                });
            }

            if (products?.length) {
                products.forEach(product => {
                    params.append('form_products[]', product);
                });
            }

            if (sectors?.length) {
                sectors.forEach(sector => {
                    params.append('form_sectors[]', sector);
                });
            }

            if (spaces?.length) {
                spaces.forEach(space => {
                    params.append('form_spaces[]', space);
                });
            }

            if (features?.length) {
                features.forEach(feature => {
                    params.append('form_features[]', feature);
                });
            }

            window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
        };

        const filterInspiration = ({
            nonce,
            colours,
            products,
            sectors,
            spaces,
            features,
            gallery,
            galleryLayout,
        }) => {
            if (!$gridInner) return;

            $gridInner.classList.add('inspiration-gallery-grid__inner--loading');

            cachios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'armourcoat_theme_ajax_get_inspiration', 
                    nonce,
                    block_anchor: $inspirationList.id,
                    colours: colours,
                    products: products,
                    sectors: sectors,
                    // spaces: spaces,
                    features: features,
                    gallery: gallery,
                    gallery_layout: galleryLayout,
                }
            }).then(response => {
                if (!response?.data?.success) return;

                if (response?.data?.modal) {
                    $modalCarouselInner.innerHTML = response.data.modal;
                    initCarouselModals();
                    initModals();
                }

                if (response?.data?.inspiration) {
                    $gridInner.innerHTML = response.data.inspiration;
                }

                if (!response?.data?.inspiration) {
                    $gridInner.innerHTML = '';
                }

                setFilterURLParams({
                    colours,
                    products,
                    sectors,
                    spaces,
                    features,
                });

                updateLoadMoreFormFields({
                    colours,
                    products,
                    sectors,
                    spaces,
                    features,
                });

                // Show/hide load more button
                if ($loadMoreForm) {
                    if (response?.data?.post_count >= response?.data?.found_posts || !response?.data?.inspiration) {
                        $loadMoreForm.classList.remove('inspiration-gallery-grid__load-more-form--show');
                    } else {
                        $loadMoreForm.classList.add('inspiration-gallery-grid__load-more-form--show');
                    }
                }
                
                const $images = $gridInner.querySelectorAll('img');

                if ($images) {
                    $images.forEach($image => {
                        $image.addEventListener('load', () => {
                            if (masonry) {
                                masonry.recalculate(true);
                            }
        
                            checkOnScreenEls();
                            initCarouselModals();
                        });
                    });
                }
            }).finally(() => {
                $gridInner.classList.remove('inspiration-gallery-grid__inner--loading');
            });
        };

        const loadMore = () => {
            if (loadingMore && $loadMoreForm.classList.contains('inspiration-gallery-grid__load-more-form--show')) {
                setTimeout(() => {
                    loadMore();
                }, 100);
            }

            if (loadingMore || !$gridInner || !$loadMoreForm || !$loadMoreForm.classList.contains('inspiration-gallery-grid__load-more-form--show')) return;

            const $nonce = $loadMoreForm.querySelector('[name="armourcoat_theme_load_more_inspiration_list_wpnonce"]');
            const $inspirationPage = $loadMoreForm.querySelector('[name="inspiration_page"]');
            const $postsPerPage = $loadMoreForm.querySelector('[name="posts_per_page"]');
            const $gallery = $loadMoreForm.querySelector('[name="gallery"]');
            const $colours = $loadMoreForm.querySelectorAll('[name="form_colours[]"]');
            const $products = $loadMoreForm.querySelectorAll('[name="form_products[]"]');
            const $sectors = $loadMoreForm.querySelectorAll('[name="form_sectors[]"]');
            const $spaces = $loadMoreForm.querySelectorAll('[name="form_spaces[]"]');
            const $features = $loadMoreForm.querySelectorAll('[name="form_features[]"]');

            const colourValues = $colours ? Array.from($colours).map($colour => $colour.value) : null;
            const productValues = $products ? Array.from($products).map($product => $product.value) : null;
            const sectorValues = $sectors ? Array.from($sectors).map($sector => $sector.value) : null;
            const spaceValues = $spaces ? Array.from($spaces).map($space => $space.value) : null;
            const featureValues = $features ? Array.from($features).map($feature => $feature.value) : null;

            loadingMore = true;

            $gridInner.classList.add('inspiration-gallery-grid__inner--loading');

            cachios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'armourcoat_theme_ajax_load_more_inspiration', 
                    nonce: $nonce?.value,
                    block_anchor: $inspirationList.id,
                    page: $inspirationPage?.value,
                    posts_per_page: $postsPerPage?.value,
                    gallery: $gallery?.value,
                    colours: colourValues,
                    products: productValues,
                    sectors: sectorValues,
                    // spaces: spaceValues,
                    features: featureValues,
                }
            }).then(response => {
                if (!response?.data?.success) return;

                if (response?.data?.inspiration) {
                    $gridInner.insertAdjacentHTML('beforeend', response.data.inspiration);
                }

                if (response?.data?.page && $inspirationPage) {
                    $inspirationPage.value = parseInt(response.data.page) + 1;
                }

                const $images = $gridInner.querySelectorAll('.inspiration-gallery-card__inner img');

                let loadedComplete = 0;

                const loadComplete = () => {
                    if (masonry) {
                        masonry.recalculate(true);
                    }
                    
                    loadedComplete++;

                    if (loadedComplete !== $images?.length) return;

                    infiniteLoad();
                    checkOnScreenEls();
                    initCarouselModals();

                    loadingMore = false;

                    if (masonry) {
                        masonry.recalculate(true);
                    }
                };

                if ($images) {
                    $images.forEach($image => {
                        if ($image?.complete) {
                            loadComplete();

                            return;
                        }

                        $image.addEventListener('load', () => {
                            loadComplete();
                        });

                        $image.addEventListener('error', () => {
                            loadComplete();
                        });
                    });
                }

                // Show/hide load more button
                if (response?.data?.post_count >= response?.data?.found_posts || !response?.data?.inspiration) {
                    $loadMoreForm.classList.remove('inspiration-gallery-grid__load-more-form--show');
                } else {
                    $loadMoreForm.classList.add('inspiration-gallery-grid__load-more-form--show');
                }
            }).finally(() => {
                $gridInner.classList.remove('inspiration-gallery-grid__inner--loading');
            });
        };

        const initFilterSelections = () => {
            if (!$filterSelections) return;

            $filterSelections.forEach($filterSelection => {
                new FilterSelection($filterSelection);
            });
        };

        const infiniteLoad = () => {
            if (!$gridInner || $gridInner.getBoundingClientRect().top + $gridInner.offsetHeight - window.innerHeight > 0) return;

            loadMore();
        };

        const initMasonry = () => {
            if (!$gridInner) return;

            masonry = Macy({
                container: $gridInner,
                columns: 3,
                margin: 0,
                breakAt: {
                    767: 2
                }
            });

            masonry.on(masonry.constants.EVENT_IMAGE_LOAD, () => {
                checkOnScreenEls();

                loadingMore = false;
            });

            masonry.runOnImageLoad(() => {
                masonry.recalculate(true);
            }, true);
            
            checkOnScreenEls();
            initCarouselModals();
        };

        const initFilterExpandable = () => {
            const $filterModalDetails = $inspirationList.querySelectorAll('.inspiration-gallery-filter-modal__filter-details');
    
            if (!$filterModalDetails) return;

            $filterModalDetails.forEach($filterModalDetails => {
                new Details($filterModalDetails);
            });
        };

        const submitFilterForm = ($form) => {
            if (!$form) return;

            const $nonce = $form.querySelector('[name=armourcoat_theme_get_inspiration_list_filter_wpnonce]');
            const $colourInputs = $form.querySelectorAll('[name="form_colours[]"]');
            const $products = $form.querySelectorAll('[name="form_products[]"]');
            const $sectors = $form.querySelectorAll('[name="form_sectors[]"]');
            const $spaces = $form.querySelectorAll('[name="form_spaces[]"]');
            const $features = $form.querySelectorAll('[name="form_features[]"]');
            const $gallery = $form.querySelector('[name="gallery"]');
            const $galleryLayout = $form.querySelector('[name="gallery_layout"]');

            let colourValues = [];
            let productValues = [];
            let sectorValues = [];
            let spaceValues = [];
            let featureValues = [];

            if ($colourInputs) {
                $colourInputs.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            colourValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        colourValues.push($input.value);
                    }
                });
            }

            if ($products) {
                $products.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            productValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        productValues.push($input.value);
                    }
                });
            }

            if ($sectors) {
                $sectors.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            sectorValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        sectorValues.push($input.value);
                    }
                });
            }

            if ($spaces) {
                $spaces.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            spaceValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        spaceValues.push($input.value);
                    }
                });
            }

            if ($features) {
                $features.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            featureValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        featureValues.push($input.value);
                    }
                });
            }

            filterInspiration({
                nonce: $nonce?.value,
                colours: colourValues,
                products: productValues,
                sectors: sectorValues,
                // spaces: spaceValues,
                features: featureValues,
                gallery: $gallery?.value,
                galleryLayout: $galleryLayout?.value,
            });
        };

        const initfilterModalForm = () => {
            if (!$filterModalForm) return;

            $filterModalForm.addEventListener('submit', e => {
                e.preventDefault();

                submitFilterForm($filterModalForm);
            });

            if ($filterModalFormInputs) {
                $filterModalFormInputs.forEach($input => {
                    $input.addEventListener('change', () => {
                        submitFilterForm($filterModalForm);
                    });
                });
            }

            if ($filterModalClearAll && $filterModalFormInputs) {
                $filterModalClearAll.addEventListener('click', () => {
                    $filterModalFormInputs.forEach($input => {
                        $input.checked = false;
                        $input.dispatchEvent(new Event('change'));
                    });

                    submitFilterForm($filterModalForm);

                    if ($filterModal) {
                        closeModal($filterModal);
                    }
                });
            }
        };

        const initFilterForm = () => {
            if (!$filter || !$filterForm) return;

            new FilterSelection($filter);
            
            $filterForm.addEventListener('submit', e => {
                e.preventDefault();

                submitFilterForm($filterForm);
            });

            $filterFormSelects.forEach($select => {
                $select.addEventListener('change', () => {
                    submitFilterForm($filterForm);
                });
            });
        };

        const initLoadMoreForm = () => {
            if (!$loadMoreForm) return;

            $loadMoreForm.addEventListener('submit', e => {
                e.preventDefault();

                loadMore();
            });
        };

        const initModal = () => {
            if ($modalCarousel) {
                modalCarousel = new Swiper($modalCarousel, {
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true
                    },
                    navigation: $modalNavNext || $modalNavPrev ? {
                        nextEl: $modalNavNext ?? null,
                        prevEl: $modalNavPrev ?? null,
                    } : false,
                    allowTouchMove: false,
                    speed: noMotionPreference.matches ? 300 : 0,
                    // autoHeight: true,
                });
            }

            if ($galleryModalExpandables) {
                $galleryModalExpandables.forEach($expandable => {
                    new Details($expandable);
                });
            }
        };

        const setModalImageHeights = () => {
            if (!$modalSlides) return;

            $modalSlides.forEach($modalSlide => {
                const $modalImageInner = $modalSlide.querySelector('.inspiration-gallery-modal__image-inner');
                const $modalImage = $modalSlide.querySelector('.inspiration-gallery-modal__image-inner img');
                const $heading = $modalSlide.querySelector('.inspiration-gallery-modal__heading');

                $modalImage.style.maxHeight = '';

                const topPos = $modalImageInner.getBoundingClientRect().top - $modal.getBoundingClientRect().top;

                $modalImage.style.maxHeight = `${window.innerHeight - topPos - ($inspirationList?.classList?.contains('inspiration-gallery--layout-simple') && $heading ? $heading.clientHeight + 24 : 0) - 16}px`;
                $modalImage.style.top = `${topPos / 2 + 8}px`;
            });
        };

        window.addEventListener('scroll', () => {
            infiniteLoad();
        });

        window.addEventListener('resize', () => {
            setModalImageHeights();
        });

        initFilterSelections();
        initMasonry();
        initFilterExpandable();
        initfilterModalForm();
        initFilterForm();
        initLoadMoreForm();
        initModal();
        setModalImageHeights();
    });
})();
